module.exports = __webpack_public_path__ + "img/ic-index.6fe78e7d.svg";